import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';
import './App.css';
import Login from './components/Login';
import Header from './components/Header';
import Home from './components/Home';
import Footer from './components/Footer';
import Search from './components/Search';
import History from './components/History';
import Loading from './components/Loading';
import { useEffect } from 'react';
import SignUp from './components/SignUp';
import Reset from './components/PassReset';

function App() {

  let homePage;

  if (localStorage.getItem("userID")) {
    homePage = (
      <>
        <Header />
        <Loading />
        <Home />
        <Footer />
      </>
    )
  }
  else {
    homePage = (
      <>
        <Loading />
        <Login />
      </>
    )
  }

  let signUp;

  if (localStorage.getItem("userID")) {
    signUp = (
      <>
        <Header />
        <Loading />
        <Home />
        <Footer />
      </>
    )
  }
  else {
    signUp = (
      <>
        <Loading />
        <SignUp />
      </>
    )
  }

  return (
    <Router basename={process.env.PUBLIC_URL}>
      <div className="App">
        <Switch>
          <Route path="/search">
            {(localStorage.getItem("userID")) ?
              <>
                <Header />
                <Loading />
                <Search />
                <Footer />
              </> :
              <div className="unauthorized-message">
                <h2>Page Access Not Authorized</h2>
                <p>Please log in to access this page.</p>
                <Link to="/" className="unauthorized-link">Go to Login</Link>
              </div>
            }
          </Route>
          <Route path="/history">
            {(localStorage.getItem("userID")) ?
              <>
                <Header />
                <Loading />
                <History />
                <Footer />
              </> :
              <div className="unauthorized-message">
                <h2>Page Access Not Authorized</h2>
                <p>Please log in to access this page.</p>
                <Link to="/" className="unauthorized-link">Go to Login</Link>
              </div>
            }
          </Route>
          <Route path="/empty">
            <div className="verification-message">
              <h2>Verification Link Sent!</h2>
              <p>Verification link sent to your email!</p>
              <p>Please click on the link to verify your email, then log in.</p>
              <Link to="/" className="verification-link">Go to Login</Link>
            </div>
          </Route>
          <Route path="/signup">
            {signUp}
          </Route>
          <Route path="/reset">
            <Reset />
          </Route>
          <Route path="/">
            {homePage}
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
